import { CurrencyPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { PublicCatalogItem, PublicCatalogBenefit, PublicCatalogMedia, PublicCatalogPlan } from 'src/app/models/catalogs/public-catalog';
import { PublicCatalogService } from 'src/app/services/public-catalog.service';
import { PortalToBodyDirective } from 'src/app/directives/portal-to-body.directive';
import { ImagePreviewComponent } from 'src/app/components/shared/image-preview/image-preview.component';

@Component({
  selector: 'app-available-services-detail',
  standalone: true,
  templateUrl: './available-services-detail.component.html',
  styleUrls: ['./available-services-detail.component.css'],
  imports: [NgClass, CurrencyPipe, NgIf, NgFor, PortalToBodyDirective, ImagePreviewComponent]
})
export class AvailableServicesDetailComponent {
  private route = inject(ActivatedRoute);
  private catalogService = inject(PublicCatalogService);
  private sanitizer = inject(DomSanitizer);

  item: PublicCatalogItem | null = null;
  media: PublicCatalogMedia[] = [];
  benefits: PublicCatalogBenefit[] = [];
  plans: PublicCatalogPlan[] = [];

  pdfPreviewSafe: SafeResourceUrl | null = null;
  pdfPreviewName = '';

  fileBaseUrl = `${environment.api.url}/File/ViewFile`;
  safeDescription: SafeHtml | null = null;

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const id = Number(params['id']);
      if (!id) return;
 
      this.catalogService.getPublicCatalog(1, 20, undefined, 1).subscribe({
        next: (res:any) => {
          let resp = res.items.find((i:PublicCatalogItem) => i.id === id);
          console.log(resp);
          this.item = resp|| [];
          this.media = resp.media ?? [];
          this.benefits = resp.benefits ?? [];
          this.plans = resp.plans ?? [];
          if (resp.longDescription) {
            this.safeDescription = this.sanitizer.bypassSecurityTrustHtml(resp.longDescription);
          }
        }
      });
    });
  }

  get mainActionLabel(): string {
    if (!this.item) return 'Seleccionar';
    return this.item.functionalTypeName?.toLowerCase() === 'servicio' ? 'Solicitar' : 'Comprar';
  }

  onMainAction(plan?: PublicCatalogPlan): void {
    if (!this.item) return;
    if (plan) {
      console.log(`Acción: ${this.mainActionLabel} plan ${plan.name} de ${this.item.title}`);
    } else {
      console.log(`Acción: ${this.mainActionLabel} ${this.item.title}`);
    }
  }

  isImage(m: PublicCatalogMedia): boolean { return (m.mediaType || '').toUpperCase() === 'IMAGE'; }
  isVideo(m: PublicCatalogMedia): boolean { return (m.mediaType || '').toUpperCase() === 'VIDEO'; }
  isPdf(m: PublicCatalogMedia): boolean { return (m.mediaType || '').toUpperCase() === 'PDF'; }

  openPdf(m: PublicCatalogMedia): void {
    const src = `${this.fileBaseUrl}/${m.fileId}`;
    this.pdfPreviewSafe = this.sanitizer.bypassSecurityTrustResourceUrl(src);
    this.pdfPreviewName = m.caption || 'Documento.pdf';
    const modal = new (window as any).bootstrap.Modal(document.getElementById('pdfModal'));
    modal.show();
  }

  playVideo(vid: HTMLVideoElement, overlay: HTMLElement, ev?: Event) {
    ev?.stopPropagation();
    overlay.style.display = 'none';
    vid.setAttribute('controls', 'true');
    vid.muted = false;
    vid.play();
  }
  hideOverlay(overlay: HTMLElement) { overlay.style.display = 'none'; }
  showOverlay(overlay: HTMLElement) { overlay.style.display = 'flex'; }
}
